import { render, staticRenderFns } from "./JVXETableDemo.vue?vue&type=template&id=65ac2de3&scoped=true"
import script from "./JVXETableDemo.vue?vue&type=script&lang=js"
export * from "./JVXETableDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac2de3",
  null
  
)

export default component.exports